export default {
  SET_PARTNERS(state, payload) {
    state.partners = payload.items || []
    state.partnersTotal = payload.total || 0
    state.partnersLimit = payload.limit || 25
    state.partnersPage = payload.page || 1
  },
  SET_PARTNER(state, payload) {
    state.partner = payload
  },
  CLEAR_PARTNER(state) {
    state.partner = { ...state.externalPartnerModel }
  },
  SET_ASSIGNED_USERS(state, payload) {
    state.assignedUsers = payload.items || []
    state.assignedUsersTotal = payload.total || 0
  },
  SET_ASSIGNABLE_USERS(state, payload) {
    state.assignableUsers = payload.items || []
    state.assignableUsersTotal = payload.total || 0
  },
  SET_CUSTOMER_MAPPINGS(state, payload) {
    state.customerMappings = payload.items || []
    state.customerMappingsTotal = payload.total || 0
  },
  SET_CUSTOMERS_LOOKUP(state, payload) {
    state.customersLookup = payload.items || []
    state.customersLookupTotal = payload.total || 0
  },
}
